import {ApiError} from '$commons/errors/commonErrors'
import {URL} from '$config'
import {EXTERNAL_ROUTES} from '$constants/external-routes'

/**
 * @description 페이회원상태오류
 */
export class NotAuthorizedError extends ApiError {
    readonly name = 'NotAuthorizedError'

    redirectHref = `${URL.PAY}/mobile/payhome`
}

/**
 * @description 약관미동의
 */
export class NotAgreeError extends ApiError {
    readonly name = 'NotAgreeError'

    redirectHref = `${URL.PAY}/mobile/agree?url=${encodeURIComponent(this.requestURLObject.href)}`

    // payAgreeCurl=cancelURL이고 사용자가 동의 화면에서 취소하였을 때 비회원 상태로 유일하게 접근할 수 있는 https://pay.naver.com/about으로 이동한다.
    pcRedirectHref = `${URL.PC_PAY}/agree?url=${encodeURIComponent(this.requestURLObject.href)}&payAgreeCurl=cancelURL`

    readonly needReplace = true
}

/**
 * @description 이용정지
 */
export class TransactionStopError extends ApiError {
    readonly name = 'TransactionStopError'

    redirectHref = `${this.requestURLObject.origin}${EXTERNAL_ROUTES.STOP}`

    readonly needReplace = true
}

/**
 * n2c 내재화 api 에서 사용하는 authCore 미들웨어에서 발생하는 에러
 */
export class AuthInfoError extends ApiError {
    redirectUrl?: string
    replace?: boolean

    constructor(
        requestURL: string,
        public redirectUrlParam?: string,
        public options?: {replace?: boolean},
    ) {
        super(requestURL)
        this.redirectUrl = redirectUrlParam
        this.replace = options?.replace
    }

    readonly name = 'AuthInfoError'

    redirectHref = this.redirectUrl || ''

    needReplace = this.replace || false
}

/**
 * 토글 OFF 상태에서 ToggleAuth 미들웨어가 적용된 API를 호출할 때 발생하는 에러
 */
export class ToggleAuthError extends ApiError {
    readonly name = 'ToggleAuthError'
}
